module.exports = __webpack_public_path__ + "img/cpic.6b6de715.png";